<template>
  <div>
    <p class="label main_color_text" :class="{'--medium': dense}">
      Dynamisme de la construction locative libre de l'Agglomération (lgts/1000
      hab)
    </p>
    <!-- <p class="label-info">En logements / 1000 habitants</p> -->
    <div class="tle-row">
      <div class="tle-col">
        <p class="label-info small">
          {{ ratio_dynamisme_periode_passee.legend }}
        </p>
        <el-mean-slider
          :parent_data="ratio_dynamisme_periode_passee"
          property="value"
          :max="ratio_dynamisme_periode_passee.max"
          :show_max="false"
          :values="ratio_dynamisme_periode_passee.values"
          :labels="ratio_dynamisme_periode_passee.labels"
          :rootComponent="ratio_dynamisme_periode_passee"
        />
      </div>
    </div>
  </div>
</template>

<script>
import elMeanSlider from "../el-mean-slider.vue";

export default {
	components: { elMeanSlider },
	props: ["ratio_dynamisme_periode_passee", "dense"],
};
</script>